export default "__VITE_ASSET__Cb_mQKj8__"